// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
//
// The footer (S5-01, closing report 01 §O4, §O5, §U1 and §U2).
//
// WHAT WAS WRONG WITHOUT IT
// -------------------------
// The whole navigable surface of this product was five bottom-bar tabs, two of which are dropped
// at 400 px and below. So:
//
//   * **`/pricing` could not be reached from inside the product at all.** A grep for a link to it
//     found the route table, the router and the sitemap — and no component. The page exists because
//     a visitor should be able to read the price without making an account, and the only way to
//     reach it was to type the address.
//   * The six documents S4 published — privacy, accessibility, terms, support, how to play, about —
//     would have had the same problem the day they shipped, and a privacy policy nobody can find is
//     a privacy policy that does not exist. A Store submission asks for the URL; a person asks for
//     the link.
//
// A footer is also the honest answer for a crawler: internal links are how whatever authority this
// site earns gets distributed, and eight of these pages had none pointing at them.
//
// **No `title` on a text link, deliberately.** The convention here puts a `title` on every button
// and input because several of them are a glyph with no accessible name at all. A text link already
// has one — its text — and a `title` that repeats it makes a screen reader say it twice.
//
// **Removed in focus mode**, like both navigation rows and for the reason `AppShell` states: a
// player who has pulled the plunger has said they are playing, and a hidden-but-present footer
// would put nine more stops in the tab order of a machine with a ball in it.

import { Link } from 'react-router'
import { useLocalisation } from '../i18n/useLanguage'
import { FOOTER_LINKS } from '../navigation'

export function SiteFooter(): React.JSX.Element {
  const { t } = useLocalisation()
  return (
    <footer className="site-footer">
      <nav className="site-footer__nav" aria-label={t('footer.heading')}>
        {FOOTER_LINKS.map((link) => (
          <Link className="site-footer__link" key={link.to} to={link.to}>
            {t(link.label)}
          </Link>
        ))}
      </nav>
      {/*
        The copyright line every file in this repository opens with, on the one surface a visitor
        can read it from — and the organisation a privacy policy has to be able to name.
      */}
      <p className="site-footer__note">© 2026 Holmes Computer Consultants</p>
    </footer>
  )
}
